// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"48":"43324cfcd5881b8d1338","60":"95aec6827e5552353839","232":"f50123d7756b6747476e","801":"1012e2fcaad1860b87e0","802":"7c0aeda619aec7ccc39f"}[chunkId] + ".js";
};